module.exports = __webpack_public_path__ + "static/img/level.27095280.png";